/**
 * i18n setup for Carnaf PWA.
 *
 * Default language: Hebrew (RTL). English + Arabic supported at launch;
 * remaining languages defer to post-launch per eng plan §15 Week 16.
 *
 * Cache-busting: locale JSON files are loaded with a ?v=YYYYMMDD query
 * string so Cloudflare CDN refreshes when we edit copy. Bump the date
 * any time you change a locale file (mirrors the Scout PWA convention).
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

const CARNAF_LOCALE_VERSION = '20260526a';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'he',
    supportedLngs: ['he', 'en', 'ar'],
    defaultNS: 'translation',
    interpolation: { escapeValue: false },
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${CARNAF_LOCALE_VERSION}`,
    },
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

// Set <html dir + lang> on every language change so RTL flips correctly.
i18n.on('languageChanged', (lng) => {
  const dir = lng === 'he' || lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.setAttribute('lang', lng);
  document.documentElement.setAttribute('dir', dir);
});

export default i18n;
